import { io } from 'socket.io-client';

// One place that knows where Socket.io lives. The socket server runs on the
// same host as the API, so derive the URL from REACT_APP_API_URL (which
// production already sets for axios) unless REACT_APP_SOCKET_URL overrides
// it explicitly. Dev falls back to the local backend.
//
// Previously KDS connected to window.location.origin (the static site host,
// which runs no socket server) and Orders fell back to localhost:5002 even
// in production — both dead ends.
const SOCKET_URL = (
  process.env.REACT_APP_SOCKET_URL ||
  process.env.REACT_APP_API_URL ||
  'http://localhost:5002'
).replace(/\/api\/?$/, '');

// The server authenticates the connection itself (see socket.service.js)
// and derives the tenant from the token — never from anything the client
// sends after connecting — so every socket must carry it from the start.
//
// `auth` is a callback, not a plain object: socket.io-client calls it fresh
// on every (re)connect attempt. A KDS/Orders screen is realistically left
// open for a whole shift, so a plain object would keep resending whatever
// token happened to exist at the original page load, even after it's
// expired or been rotated by a re-login in another tab — silently killing
// reconnects until the page is manually reloaded.
export const connectSocket = () => io(SOCKET_URL, {
  auth: (cb) => cb({ token: localStorage.getItem('token') }),
});
